import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Link, Typography } from '@fiverr-private/typography';
import { Box, theme } from '@fiverr-private/theme';
import { PressRelease } from '../../../types/types';
import { DateLine } from '../DateLine';

export const SelectedPressRelease = ({ selectedPressRelease }: { selectedPressRelease: PressRelease }) => (
  <>
    <blockquote>
      <DateLine date={selectedPressRelease.data.date} marginTop="5" />
      <Typography
        as="h2"
        size={{ default: 'h_xl', md: 'h_3xl' }}
        marginTop="2"
        marginBottom={{ default: '8', md: '20' }}
        maxWidth="750px"
        lineHeight={{ default: 'h_xl', md: 'h_3xl' }}
        style={{ fontWeight: 300 }}
      >
        {selectedPressRelease.data.title}
      </Typography>
      <Container
        width="100%"
        height={{ default: '185px', md: '614px' }}
        background={`no-repeat center / cover url("${selectedPressRelease.data.image}") ${theme.colors.green_700}`}
      >
        <Link
          href={selectedPressRelease.data.source}
          target="_blank"
          width="100%"
          height="100%"
          style={{ display: 'block' }}
        />
      </Container>
      <Typography
        as="h3"
        maxWidth="640px"
        marginTop={{ default: '8', md: '20' }}
        marginBottom="8"
        marginX="auto"
        size={{ default: 'h_sm', md: 'h_lg' }}
        color="grey_1100"
        lineHeight={{ default: 'h_sm', md: 'h_xl' }}
        fontWeight="normal"
        fontFamily="serif"
      >
        {selectedPressRelease.data.teaser}
      </Typography>
      <Box
        color="grey_900"
        marginY="0"
        marginX="auto"
        maxWidth="640px"
        fontSize="b_lg"
        lineHeight="b_xxl"
        dangerouslySetInnerHTML={{ __html: selectedPressRelease.data.body }}
      />
    </blockquote>
    <Link href="/news/press-releases" decoration={{ default: 'none', hover: 'underline' }} color="green_700">
      Back
    </Link>
  </>
);
